import React, { useEffect, useState } from 'react';
import type SwiperInstance from 'swiper';
import { useSwiper } from 'swiper/react';

import styles from './Info.module.scss';

export const Info: React.FC = () => {
	const swiper = useSwiper();
	const [active, setActive] = useState(0);

	useEffect(() => {
		swiper.on('activeIndexChange', (sw: SwiperInstance) => setActive(sw.activeIndex));
		return () => {
			swiper.off('activeIndexChange');
		};
	}, [swiper]);

	return (
		<div className={styles.info}>
			{active + 1}/{swiper.slides.length || 0}
		</div>
	);
};
